import { render, staticRenderFns } from "./ChatWithHiva.vue?vue&type=template&id=86b8f36a&scoped=true&"
import script from "./ChatWithHiva.vue?vue&type=script&lang=js&"
export * from "./ChatWithHiva.vue?vue&type=script&lang=js&"
import style0 from "./ChatWithHiva.vue?vue&type=style&index=0&id=86b8f36a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b8f36a",
  null
  
)

export default component.exports